const Type = {
  danger: 'border-red text-red',
  warning: 'border-orange text-orange',
  success: 'border-green-2 text-green-2',
} as const;

type typeType = keyof typeof Type;

interface BadgeProps {
  content: string;
  type: typeType;
}

export default function Badge({content, type}: BadgeProps) {
  return (
    <span
      className={`inline-block align-middle ${Type[type]} border text-xs px-3 py-1 rounded-lg mx-2`}
    >
      <div className="flex gap-2 items-center">
        <span>{content}</span>

        <img className="h-3 w-3" src={`/images/icons/icon-check.svg`} alt="Icon Check" />
      </div>
    </span>
  );
}
